module.exports = __webpack_public_path__ + "img/multiplier6_freespins.02e5d885.png";